import { render } from "./AWindowItem.vue?vue&type=template&id=8819a776"
import script from "./AWindowItem.vue?vue&type=script&lang=js"
export * from "./AWindowItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__